import type { PropsWithChildren } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import When from "ui/support/When";

type Props = {
    readonly completed: boolean;
};

const StepCompletionIndicator = ({ completed, children }: PropsWithChildren<Props>) => (
    <Box
        sx={{
            justifySelf: 'center',
            alignSelf: 'center'
        }}
    >
        <When
            if={completed}
            then={(
                <IconButton
                    color='success'
                >
                    <CheckCircleIcon />
                </IconButton>
            )}
            else={(
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        color: 'primary.contrastText',
                        border: '1px solid',
                        borderColor: 'divider'
                    }}
                >
                    {children}
                </Box>
            )}
        />
    </Box>
);

export default StepCompletionIndicator;
